export default theme => ({
  root: {
    paddingTop: theme.spacing(1),
  },
});
